@if (!loading) {
<router-outlet />
}
@else {
<div class="spinner">
  <div class="blob"></div>
</div>
}